export enum EChallenge {
  getUserChallenge = 'challenges/getUserChallenge',
  updateUserTeamName = 'challenges/updateUserTeamName',
  updateUserChallengeStep = 'challenges/updateUserChallengeStep',
  getCompanyChallenge = 'challenges/getCompanyChallenge',
  updateCompanyChallenge = 'challenges/updateCompanyChallenge',
  resetCompanyChallenge = 'challenges/resetCompanyChallenge',
  loadChallengesReport = 'challenges/loadChallengesReport',
}
